
import NewSkeletonBox from './NewSkeletonBox.vue'
export default {
  name: 'PaginationSkeleton',
  components: {
    NewSkeletonBox
  }
}
